export default __webpack_public_path__ + "static/media/EFA2.60a0882e.webp";